var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_456_1139",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_456_1139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3077 21C4.80898 21 4.38302 20.8233 4.02982 20.4701C3.67661 20.1169 3.5 19.691 3.5 19.1923V5.8077C3.5 5.30898 3.67661 4.88302 4.02982 4.52982C4.38302 4.17661 4.80898 4 5.3077 4H9.7577C9.82052 3.44488 10.0628 2.97278 10.4846 2.58368C10.9064 2.19456 11.4115 2 12 2C12.5948 2 13.1032 2.19456 13.525 2.58368C13.9468 2.97278 14.1859 3.44488 14.2423 4H18.6923C19.191 4 19.6169 4.17661 19.9701 4.52982C20.3233 4.88302 20.5 5.30898 20.5 5.8077V19.1923C20.5 19.691 20.3233 20.1169 19.9701 20.4701C19.6169 20.8233 19.191 21 18.6923 21H5.3077ZM5.3077 19.5H18.6923C18.7692 19.5 18.8397 19.4679 18.9038 19.4038C18.9679 19.3397 19 19.2692 19 19.1923V5.8077C19 5.73077 18.9679 5.66024 18.9038 5.59613C18.8397 5.53203 18.7692 5.49998 18.6923 5.49998H5.3077C5.23077 5.49998 5.16024 5.53203 5.09612 5.59613C5.03202 5.66024 4.99997 5.73077 4.99997 5.8077V19.1923C4.99997 19.2692 5.03202 19.3397 5.09612 19.4038C5.16024 19.4679 5.23077 19.5 5.3077 19.5ZM7.25 17.1346H13.75V15.6346H7.25V17.1346ZM7.25 13.25H16.75V11.75H7.25V13.25ZM7.25 9.36535H16.75V7.86538H7.25V9.36535ZM12 4.84613C12.2166 4.84613 12.3958 4.77529 12.5375 4.63363C12.6791 4.49196 12.75 4.31279 12.75 4.09613C12.75 3.87946 12.6791 3.70029 12.5375 3.55863C12.3958 3.41696 12.2166 3.34613 12 3.34613C11.7833 3.34613 11.6041 3.41696 11.4625 3.55863C11.3208 3.70029 11.25 3.87946 11.25 4.09613C11.25 4.31279 11.3208 4.49196 11.4625 4.63363C11.6041 4.77529 11.7833 4.84613 12 4.84613Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.bb4ed679f95202f4be5c12e49f8ffdaa.svg";
export { ForwardRef as ReactComponent };